import type { SVGProps } from "react";

const AdvertisingCurrencyLine = ({
  className,
  ...props
}: { className?: string } & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="115"
      height="114"
      viewBox="0 0 115 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M113.333 7.62939e-06C113.886 7.62939e-06 114.333 0.447716 114.333 1.00001C114.333 1.55229 113.886 2.00001 113.333 2.00001V1.00001V7.62939e-06ZM5.33337 108L5.33338 107L40.8334 107V108L40.8333 109L5.33337 109L5.33337 108ZM60.8334 88H59.8334V21H60.8334H61.8334V88H60.8334ZM80.8334 1.00005L80.8333 4.57764e-05L113.333 7.62939e-06V1.00001V2.00001L80.8334 2.00005V1.00005ZM60.8334 21H59.8334C59.8334 9.40206 69.2354 6.10352e-05 80.8333 4.57764e-05L80.8334 1.00005V2.00005C70.34 2.00006 61.8334 10.5066 61.8334 21H60.8334ZM40.8334 108V107C51.3268 107 59.8334 98.4934 59.8334 88H60.8334H61.8334C61.8334 99.598 52.4313 109 40.8333 109L40.8334 108Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AdvertisingCurrencyLine;
